// extracted by mini-css-extract-plugin
export default {"form":"Exchange_form__lz+x+","form_group":"Exchange_form_group__5Gbs5","form_groups":"Exchange_form_groups__KzOd6","bouton":"Exchange_bouton__IbYSu","gras":"Exchange_gras__G+HfH"};